/**
 * Max height of the scrollable table area on the rebate screens. Both Handle
 * rebates and Rebates follow up have identical chrome above the table
 * (page header, card header and filter row), so they share the same offset.
 */
export const rebatesTableMaxHeight = "calc(100vh - 260px)";
